import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { initializeKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import {
  listUnresolvedDepartmentsContract,
  type ListUnresolvedDepartmentsResponse,
  type UnresolvedDepartment
} from '@bliks-io/contracts';

/**
 * Shared query options for unresolved departments (manager not yet resolved).
 * Used by both the hook and route-level loaders (initial-setup resume).
 */
export const unresolvedDepartmentsQueryOptions = {
  queryKey: initializeKeys.unresolvedDepartments(),
  queryFn: async ({ signal }: { signal?: AbortSignal } = {}): Promise<UnresolvedDepartment[]> => {
    const { data } = await apiClient.get<ListUnresolvedDepartmentsResponse>(
      listUnresolvedDepartmentsContract.path,
      { signal }
    );
    return data;
  }
};

/**
 * Departments awaiting manager assignment. Auto-resolution now runs
 * synchronously inside the users import request, so no polling is needed —
 * the awaited invalidations after the import already refetch this list.
 */
export function useInitializeUnresolvedDepartments() {
  const { token } = useAuthStore();

  return useQuery({ ...unresolvedDepartmentsQueryOptions, enabled: !!token });
}
